import AdditionalInfoAccordion from "./additionalInfoAccordion.container";

export default AdditionalInfoAccordion;
